import React, { Component } from "react";
import apiClient from "../../actions/api-client"; // adjust path
import "./link-selection.css"; // create this CSS file for styling
import TextFieldGroup from "../forms/text-field-group";

class LinkPreviewInput extends Component {
  constructor(props) {
    super(props);
    this.state = {  
      link: props.value ? props.value.url || "": "",
      displayName: props.value ? props.value.name || "": "",
      icon: props.value ? props.value.icon || "": "",
      loading: false,
    };
    console.log(this.state);
    
  }

  componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
          const newState={};
          if (this.props.value && this.props.value.url !== this.state.link) {
              newState.link = this.props.value.url || "";
          }
          if (this.props.value && this.props.value.name !== this.state.displayName) {
              newState.displayName = this.props.value.name || "";
          }
          if (this.props.value && this.props.value.icon !== this.state.icon) {
              newState.icon = this.props.value.icon || "";
          }
          if (Object.keys(newState).length > 0) {
              this.setState(newState);
          }
      }
  }


  handleChange = (field, value) => {
    this.setState( 
      {[field]: value,},
      this.emitChange,
    );
  };

  emitChange = () => {
    const { link, displayName, icon } = this.state;

    this.props.onChange &&
      this.props.onChange({
        link,
        displayName,
        icon,
      });
  };

  fetchPreview = async (value) => {
    if (!value) return;

    this.props.showIndicator && this.props.showIndicator();
    this.setState({ loading: true });
    try {
      const pathTemplate = "/getLinkDetails?url=" + encodeURIComponent(value);

      const result = await apiClient.invokeApi({}, pathTemplate, "GET", {}, {});

      if (result.status === 200) {
        this.setState(
          (prev) => ({
            link: result.data.url || value,
            icon: result.data.favicon,
            displayName: result.data.title || prev.displayName,
          }),
          this.emitChange,
        );
      }
    } catch (err) {
      console.error("Preview fetch failed:", err);
    } finally {
      this.setState({ loading: false });
      this.props.hideIndicator && this.props.hideIndicator();
    }
  };

  render() {
    const { link, displayName, icon, loading } = this.state;

    return (
      <div className="guide-link">
        <TextFieldGroup
          label="Display Name (optional)"
          field="DisplayName"
          value={displayName}
          placeholder="Enter Display Name (optional)"
          onChange={(e) => this.handleChange("displayName", e.target.value)}
          selectWidth={false}
        />

        <TextFieldGroup
          label="Link"
          field="guidLink"
          value={link}
          placeholder="Enter Link"
          onChange={(e) => this.handleChange("link", e.target.value)}
          onBlur={(e) => this.fetchPreview(e.target.value)}
          selectWidth={false}
        />

        {loading && <div className="link-loading">Fetching preview...</div>}

        {!loading && link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="testing-link"
          >
            {icon && (
              <img
                height="15"
                width="15"
                src={icon}
                alt={displayName}
                style={{ marginRight: "6px" }}
              />
            )}
            {displayName || link}
          </a>
        )}
      </div>
    );
  }
}

export default LinkPreviewInput;
